import {
	avatar,
	btn,
	comp,
	Component, ComponentEventMap,
	DataSourceStore,
	datasourcestore,
	Format,

	Notifier,
	QuoteStripper,
	t,
	win
} from "@intermesh/goui";
import {client, Image, img, JmapDataSource, jmapds} from "@intermesh/groupoffice-core";


export interface CommentListEventMap extends ComponentEventMap {

	listready: {}
}


export class CommentList extends Component<CommentListEventMap> {
	store: DataSourceStore;

	constructor() {
		super();

		this.cls = "comments main";

		this.store = datasourcestore({
			dataSource: jmapds("Comment"),
			listeners: {
				load: ( {records}) => {
					const comments = this;

					//comments.items.clear();

					const imgProms: Promise<any>[] = [],
						cmps = records.map(record => {

						const qs = new QuoteStripper(record.text), quote = qs.getQuote();

						let quoteLess = qs.getBodyWithoutQuote();


						const text = comp({
							cls: "text normalize",
							html: quoteLess,
							listeners: {

								beforerender: ({target}) => {
									imgProms.push(Image.replaceImages(target.el));

									// Enlarge images when clicked in window
									target.el.addEventListener("click", (e) => {
										if (e.target && (e.target as HTMLElement).tagName == "IMG") {
											const img = e.target as HTMLImageElement

											const imageWin = win({
													width: window.innerWidth - 50,
													height: window.innerHeight - 50,
													maximized: true,
													maximizable: true,
													modal: true,
													title: img.alt ?? "Image",
												},
												comp({
													flex: 1,
													itemId: "img-cont",

													style: {
														alignItems: "center",
														justifyContent: "center"
													},
													listeners: {
														beforerender: ({target}) => {
															const i = img.cloneNode() as HTMLImageElement;
															i.style.height = "100%";
															i.style.width = "100%";
															i.style.objectFit = "contain";
															target.el.appendChild(i);
														}
													}
												})
											);

											imageWin.show();

										}
									});
								}
							}
						});

						const name = record.creator?.name ?? t("Unknown user");

						const comment = comp({
								cls: "comment"
							},
							comp({
									cls: "meta"
								},
								record.creator?.avatarId ?

									img({
										cls: "goui-avatar",
										blobId: record.creator.avatarId,
										title: name
									}) :

									avatar({
										displayName: name
									}),

								comp({
									cls: "author",
									html: name
								}),
								comp({cls: "divider"}),

								comp({
									cls: "date",
									html: Format.dateTime(record.createdAt)
								})
							),

							text

						)

						if(quote) {
							text.items.add(
								btn({
									cls: "raised",
									text: t("More"),
									handler: (btn) => {
										text.html = record.text;

										Image.replaceImages(text.el);
										btn.remove();
									}
								})
							);
						}

						const attachments = comp({cls: "attachments"});

						record.attachments.forEach((a: any) => {
							attachments.items.add(
								btn({
									icon: "description",
									text: a.name,
									handler: () => {
										client.downloadBlobId(a.blobId, a.name).catch((error) => {
											Notifier.error(error);
										})
									}
								}))
						});

						comment.items.add(attachments);

						return comment;
					});

					comments.items.replace(...cmps);

					Promise.all(imgProms).then(() => {
						this.fire("listready", {});
					})
				}
			},
			relations: {
				creator: {
					path: "createdBy",
					dataSource: jmapds("Principal")
				}
			},
			queryParams: {
				filter: {
					entity: "SupportTicket"
				}
			}
		});
	}
}